import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { FilterSidebar } from '../components/FilterSidebar';
import { FilmCard } from '../components/FilmCard';
import { Button } from '../components/ui/Button';
import { SearchBar } from '../components/SearchBar';
import { useSearchFilms } from '../hooks/useFilms';
import { Filter, Search as SearchIcon, Loader2 } from 'lucide-react';
export function SearchResults() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const {
    films: results,
    loading
  } = useSearchFilms(query);
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-643">
      <div className="container mx-auto px-4 py-12" data-id="element-644">
        {/* Search Header */}
        <div className="mb-12" data-id="element-645">
          <h1 className="font-noir text-4xl text-white mb-8" data-id="element-646">
            Результаты поиска
          </h1>
          <div className="flex gap-4" data-id="element-647">
            <SearchBar variant="compact" initialValue={query} className="max-w-2xl" data-id="element-648" />
            <Button variant="outline" className="shrink-0 border-[#333] text-gray-400 hover:text-white" onClick={() => setIsFilterOpen(true)} data-id="element-649">
              <Filter className="w-4 h-4 mr-2" data-id="element-650" />
              Фильтры
            </Button>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-10" data-id="element-651">
          <FilterSidebar isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} className="w-full md:w-72 shrink-0" data-id="element-652" />

          <div className="flex-1" data-id="element-653">
            {loading ? <div className="flex flex-col items-center justify-center py-32" data-id="element-654">
                <Loader2 className="w-10 h-10 text-[#D22B2B] animate-spin mb-4" data-id="element-655" />
                <p className="text-gray-500 font-serif text-sm uppercase tracking-widest" data-id="element-656">
                  Поиск фильмов...
                </p>
              </div> : results.length > 0 ? <div className="space-y-8" data-id="element-657">
                <p className="text-xs font-serif font-bold uppercase tracking-[0.2em] text-[#D22B2B]" data-id="element-658">
                  Найдено {results.length} совпадений
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-id="element-659">
                  {results.map((film, idx) => <div key={film.id} className="flex flex-col gap-3" data-id="element-660">
                      {idx === 0 && <div className="text-[10px] font-bold text-[#D22B2B] bg-[#D22B2B]/10 px-2 py-1 border border-[#D22B2B]/20 inline-block w-fit tracking-wider uppercase" data-id="element-661">
                          Лучшее совпадение
                        </div>}
                      <FilmCard film={film} index={idx} data-id="element-662" />
                    </div>)}
                </div>
              </div> : <div className="flex flex-col items-center justify-center py-32 border border-[#222] bg-[#141414]/50" data-id="element-663">
                <div className="bg-[#1a1a1a] text-gray-500 p-6 rounded-full mb-6 border border-[#333]" data-id="element-664">
                  <SearchIcon className="w-10 h-10" data-id="element-665" />
                </div>
                <h2 className="font-noir text-3xl text-white mb-3" data-id="element-666">
                  Ничего не найдено
                </h2>
                <p className="text-gray-500 mb-10 text-center max-w-md font-serif font-light" data-id="element-667">
                  {query ? `По запросу "${query}" ничего не найдено. Попробуйте изменить запрос или перейдите в общий каталог.` : 'Введите запрос для поиска фильмов.'}
                </p>
                <Link to="/catalog" data-id="element-668">
                  <Button variant="primary" data-id="element-669">Перейти в каталог</Button>
                </Link>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}